import * as React from 'react';
import { UIText1, UIText2 } from '@cian/ui-kit';
import { IconProductEscrou16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'clsx';

import * as styles from './styles.css';
import { SalesStartTooltip } from '../../../SalesStartTooltip';

interface IHouseItemProps {
  active: boolean;
  title: string;
  finishStatus?: string;
  isEscrow?: boolean;
  isSalesStart?: boolean;
}

export function HouseItem({ active, title, finishStatus, isEscrow = false, isSalesStart = false }: IHouseItemProps) {
  return (
    <div className={classNames(styles['container'], active && styles['active'])}>
      <div className={styles['title']}>
        <UIText1>{title}</UIText1>
        <div className={styles['labels']}>
          {isEscrow && <IconProductEscrou16 color="icon-main-default" data-testid="IconEscrou16" />}
          {isSalesStart && <SalesStartTooltip />}
        </div>
      </div>
      {finishStatus && <UIText2 color="gray60_100">{finishStatus}</UIText2>}
    </div>
  );
}
